module.exports = require('./LicenseCollectorRepossessorEmployeeApplicationView');
